module.exports = require('./LicenseCollectorRepossessorEmployeeApplicationView');
